export const loadRazorpayScript = () => {
const body = document.body;
const razorpayScript = document.createElement("script");
razorpayScript.src= "https://checkout.razorpay.com/v1/checkout.js";
razorpayScript.async = true;
body.append(razorpayScript);
}